export default __webpack_public_path__ + "static/annas-327a5a608e0fbd2b1d314de91d85f373.webp";